/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSkillVersionContentRequest = {
  skillId: string;
  version: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSkillVersionContentRequest$inboundSchema: z.ZodType<
  GetSkillVersionContentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  version: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSkillVersionContentRequest$Outbound = {
  skill_id: string;
  version: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSkillVersionContentRequest$outboundSchema: z.ZodType<
  GetSkillVersionContentRequest$Outbound,
  z.ZodTypeDef,
  GetSkillVersionContentRequest
> = z.object({
  skillId: z.string(),
  version: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSkillVersionContentRequestToJSON(
  getSkillVersionContentRequest: GetSkillVersionContentRequest,
): string {
  return JSON.stringify(
    GetSkillVersionContentRequest$outboundSchema.parse(
      getSkillVersionContentRequest,
    ),
  );
}
export function getSkillVersionContentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSkillVersionContentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSkillVersionContentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSkillVersionContentRequest' from JSON`,
  );
}
